/** "Super Admin (no pay & contracts)" is the super_admin role with hide_pay_and_contracts on.
 *  It is listed as a role of its own, but this key exists only in the interface: the backend
 *  keeps role 'super_admin', so every Super Admin permission stays identical. */
export const SUPER_ADMIN_RESTRICTED = 'super_admin_restricted'

type RoleHolder = { role?: string | null; hide_pay_and_contracts?: boolean | null }

export function roleKeyOf(person: RoleHolder): string {
  return person.role === 'super_admin' && person.hide_pay_and_contracts ? SUPER_ADMIN_RESTRICTED : person.role || 'user'
}

/** The fields to save when someone is given the role behind a role key. */
export function roleAssignment(key: string): { role: string; hide_pay_and_contracts?: boolean } {
  if (key === SUPER_ADMIN_RESTRICTED) return { role: 'super_admin', hide_pay_and_contracts: true }
  if (key === 'super_admin') return { role: 'super_admin', hide_pay_and_contracts: false }
  return { role: key }
}

/** Employee-list filters for the members of a role key. */
export function roleMemberFilters(key: string): { [field: string]: string[] } {
  if (key === SUPER_ADMIN_RESTRICTED) return { role: ['super_admin'], hide_pay_and_contracts: ['true'] }
  if (key === 'super_admin') return { role: ['super_admin'], hide_pay_and_contracts: ['false'] }
  return { role: [key] }
}

/** Profile tabs about a colleague's pay, contract or personal documents. */
export const PAY_AND_CONTRACT_PROFILE_TABS = ['compensation', 'benefits', 'documents']

/** Payroll tabs that show pay; working days and expenses stay available. */
export const PAY_PAYROLL_TABS = ['overview', 'people', 'benefits']

/** Employee form fields with pay or contract terms. */
export const PAY_AND_CONTRACT_FIELDS = new Set([
  'salary', 'starting_salary', 'currency', 'contract_type', 'contract_duration',
  'probation_end_date', 'temporary_contract_end_date',
])
